import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLoginInfo } from '../actions/auth';
import { SSO_RETURN_PATH_KEY } from '../util/appSignIn';
import { loginMicrosoftDestination } from '../util/ssoSignIn';

class LoginMicrosoft extends Component {
  constructor() {
    super();
    this.state = {
      finishedLoad: false,
    };
  }

  componentDidMount() {
    this.getInfo();
  }

  getInfo = async () => {
    const { getLoginInfo: getUserInfo } = this.props;
    await getUserInfo();
    this.setState({ finishedLoad: true });
  }

  render() {
    const { finishedLoad } = this.state;
    const { location } = this.props;

    if (finishedLoad) {
      const path = sessionStorage.getItem(SSO_RETURN_PATH_KEY);
      sessionStorage.removeItem(SSO_RETURN_PATH_KEY);
      return (<Redirect to={loginMicrosoftDestination(location.search, path)} />);
    }

    return null;
  }
}

LoginMicrosoft.propTypes = {
  location: PropTypes.object.isRequired,
  getLoginInfo: PropTypes.func.isRequired,
}

export default connect(null, { getLoginInfo })(LoginMicrosoft);

export {
  LoginMicrosoft,
};
